import ContainerBlockGenericType from "../ContainersBlocks/ContainerBlockGenericType";

function MAVG
    ({ id, isConnectable, type, selected }) {
    return (
        <ContainerBlockGenericType
            id={id}
            isConnectable={isConnectable}
            type={type}
            selected={selected}
            flagNumber={42}
            showLabelInput={true}
            userConfiguration={true}
        />
    );
}
export default MAVG
